import { borrowSubtractionExplanation, createNaturalArithmeticTask, randInt } from "./sharedNaturalArithmetic";

function pickData() {
  for (let i = 0; i < 300; i += 1) {
    const a = randInt(21, 98);
    const b = randInt(2, 9);
    if (a % 10 > 0 && a % 10 < b) return { a, b, op: "-", result: a - b };
  }
  return { a: 35, b: 7, op: "-", result: 28 };
}

const mod = createNaturalArithmeticTask({
  type: "NaturalSubTeenBorrowTask",
  pickData,
  explain: borrowSubtractionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
